export default "__VITE_ASSET__C2pewc$6__"